import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button, Alert, Box, Chip, Snackbar, CircularProgress, LinearProgress, Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PdfPlaceholder from '../assets/pdf-icon.svg';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CloseIcon from '@mui/icons-material/Close';
import Logo from '../assets/logo.png';
import FAQ from './FAQ';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CountdownBanner from './CountdownBanner';

const FileList = ({ folderId }) => {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [error1, setError1] = useState(null);
  const [downloadingFiles, setDownloadingFiles] = useState({});
  const [downloadedFiles, setDownloadedFiles] = useState({});
  const [downloadProgress, setDownloadProgress] = useState({});
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [bestsellerImages, setBestsellerImages] = useState([]);
  const [message, setMessage] = useState(null); // State to hold the success or error message for /clear endpoint
  const [failedImages, setFailedImages] = useState({}); // Track which images failed to load
  const [currentSku, setCurrentSku] = useState(''); // Store the current SKU
  const [showCountdown, setShowCountdown] = useState(false); // Control countdown visibility
  
  // Safe image loading function that returns null if image not found
  const safelyLoadImage = (imageName) => {
    try {
      return require(`../assets/${imageName}`);
    } catch (error) {
      console.warn(`Could not load image: ${imageName}`, error);
      return null;
    }
  };

  // Mark an image as failed to load
  const handleImageError = (itemId) => {
    setFailedImages(prev => ({
      ...prev,
      [itemId]: true
    }));
  };
  const baseURL = window.location.hostname.includes('localhost') || 
                 window.location.hostname.includes('127.0.0.1') 
                 ? 'http://backend.localhost' 
                 : 'https://api.antiquewhiteart.com';

  const sortedSizes = ['5x7', '8x10', '9x12', '11x14', '16x20', '18x24', '24x36', 'ISO A2'];

  useEffect(() => {
    if (!folderId) {
      window.location.href = 'https://antiquewhite.art';
      return;
    }

    axios.get(`${baseURL}/files/${folderId}`)
      .then(response => {
        // Group files by prefix (e.g., 1_Print, 2_Print, Bonus_Print)
        const groupedFiles = response.data.reduce((acc, file) => {
          const match = file.name.match(/^(bonus|[\d]+)(_Print)?/i);
          if (match) {
            const groupKey = match[0];
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(file);
          } else {
            acc[file.name] = [file]; // Non-grouped files handled as a single group
          }
          return acc;
        }, {});
    
        setFiles(groupedFiles);
        setLoading(false);

        // Get the SKU from the first file in the first group
        const firstGroup = Object.values(groupedFiles)[0];
        const extractedSku = firstGroup && firstGroup[0] && firstGroup[0].sku ? firstGroup[0].sku : '';
        setCurrentSku(extractedSku);
        
        // Determine if we should show countdown banner based on SKU prefix
        // Show for non-frame TV products (SKU not starting with TV, TS, or WA)
        const shouldShowCountdown = extractedSku && 
          !(extractedSku.startsWith('TV') || extractedSku.startsWith('TS') || extractedSku.startsWith('WA'));
        setShowCountdown(shouldShowCountdown);

                // Winter
        // const frameItems = [
        //   { imgSrc: 'TS28.jpg', name: 'Christmas Frame TV', url: 'https://antiquewhite.art/listing/1596162078' },
        //   { imgSrc: 'WA86.jpg', name: 'Santa Claus Frame TV', url: 'https://antiquewhite.art/listing/1819219591' },
        //   { imgSrc: 'WA71.jpg', name: 'Christmas Sleigh Frame TV', url: 'https://antiquewhite.art/listing/1804358244' },
        //   { imgSrc: 'WA76.jpg', name: 'Bunnies in Snowy Forest', url: 'https://antiquewhite.art/listing/1818584613' },
        //   { imgSrc: 'WA70.jpg', name: 'Christmas Village Frame TV', url: 'https://antiquewhite.art/listing/1818532353' },
        // ];
        // const defaultItems = [
        //   { imgSrc: 'S38.jpg', name: 'Printed and Mailed Prints', url: 'https://antiquewhite.art/listing/1812713841' },
        //   { imgSrc: 'S88.jpg', name: 'Christmas Print Set of 8', url: 'https://antiquewhite.art/listing/1815884411' },
        //   { imgSrc: 'W113.jpg', name: 'Christmas Sleigh Print', url: 'https://antiquewhite.art/listing/1797344512' },
        //   { imgSrc: 'W110.jpg', name: 'Santa Claus Print', url: 'https://antiquewhite.art/listing/1797336266' },
        //   { imgSrc: 'W141.jpg', name: 'Santa Claus Print', url: 'https://antiquewhite.art/listing/1819625313' },
        // ];

        // // Valentines/Spring
        // const frameItems = [
        //   { imgSrc: 'TV555.jpg', name: 'Valentine\'s Frame TV', url: 'https://antiquewhite.art/listing/1856589009' },
        //   { imgSrc: 'TV256.jpg', name: 'Romantic Frame TV', url: 'https://antiquewhite.art/listing/1658434725' },
        //   { imgSrc: 'TS35.jpg', name: 'Spring bundle', url: 'https://antiquewhite.art/listing/1632216202' },
        //   { imgSrc: 'TV310.jpg', name: 'Easter Bunny Frame TV', url: 'https://antiquewhite.art/listing/1693662759' },
        //   { imgSrc: 'TS65.jpg', name: 'Valentine\'s Day Bundle', url: 'https://antiquewhite.art/listing/1856579853' },
        //   { imgSrc: 'TV539.jpg', name: 'Floral Spring Art', url: 'https://antiquewhite.art/listing/1841629622' },
        //   { imgSrc: 'TV278.jpg', name: 'Ducklings Frame TV', url: 'https://antiquewhite.art/listing/1682868263' },
        // ];
        // const defaultItems = [
        //   { imgSrc: 'A138.jpg', name: 'Easter Bunnies Print', url: 'https://antiquewhite.art/listing/1630760510' },
        //   { imgSrc: 'A208.jpg', name: 'Ducklings Easter Print', url: 'https://antiquewhite.art/listing/1677643366' },
        //   { imgSrc: 'A36.jpg', name: 'Cottage Rose Garden Print', url: 'https://antiquewhite.art/listing/1473325629' },
        //   { imgSrc: 'S79.jpg', name: 'Coastal Set of 2', url: 'https://antiquewhite.art/listing/1734012059' },
        //   { imgSrc: 'S33.jpg', name: 'Wildflower Wall Art', url: 'https://antiquewhite.art/listing/1468530635' },
        //   { imgSrc: 'S60.jpg', name: 'Spring Wall Gallery', url: 'https://antiquewhite.art/listing/1654358535' },
        //   { imgSrc: 'S56.jpg', name: 'Set of Spring Wall Art', url: 'https://antiquewhite.art/listing/1644535957' },
        //   // { imgSrc: 'S63.jpg', name: 'Set of 7 Prints', url: 'https://antiquewhite.art/listing/1656474489' },
        // ];

        // Spring/Easter
        // const frameItems = [
        //   { imgSrc: 'TV275.jpg', name: 'Spring Flowers', url: 'https://antiquewhite.art/listing/1682152615' },
        //   { imgSrc: 'TV320.jpg', name: 'Easter Bunny Ears', url: 'https://antiquewhite.art/listing/1682298480' },
        //   { imgSrc: 'TS67.jpg', name: 'Vintage Moody Set', url: 'https://antiquewhite.art/listing/1864086198' },
        //   { imgSrc: 'TS42.jpg', name: 'Easter Set', url: 'https://antiquewhite.art/listing/1663997049' },
        //   { imgSrc: 'TV572.jpg', name: 'Spring Tulip Field', url: 'https://antiquewhite.art/listing/1872558259' },
        //   { imgSrc: 'TV565.jpg', name: 'Easter Bunnies', url: 'https://antiquewhite.art/listing/1867631813' },

        // ];
        // const defaultItems = [
        //   { imgSrc: 'A401.jpg', name: 'Cottage Garden', url: 'https://antiquewhite.art/listing/1859408150' },
        //   { imgSrc: 'S63.jpg', name: 'Wildflower Prints', url: 'https://antiquewhite.art/listing/1656474489' },
        //   { imgSrc: 'A416.jpg', name: 'Easter Bunny Print', url: 'https://antiquewhite.art/listing/1863460572' },
        //   { imgSrc: 'A381.jpg', name: 'Easter Bunny Sketch', url: 'https://antiquewhite.art/listing/1866518495' },
        //   { imgSrc: 'S79.jpg', name: 'Coastal Set', url: 'https://antiquewhite.art/listing/1734012059' },
        // ];

        // Summer items
        const frameItems = [
          { imgSrc: 'TV432.jpg', name: '4th of July Bestseller', url: 'https://antiquewhiteart.etsy.com/listing/1718257360', sku: 'TV432' },
          { imgSrc: 'TV06.jpg', name: 'Late Summer Wildflower Field', url: 'https://antiquewhiteart.etsy.com/listing/1473669321', sku: 'TV06' },
          { imgSrc: 'TS51.jpg', name: 'Independence Day Set', url: 'https://antiquewhiteart.etsy.com/listing/1723175092', sku: 'TS51' },

          { imgSrc: 'TV430.jpg', name: 'Fireworks Frame TV', url: 'https://antiquewhiteart.etsy.com/listing/1732453409', sku: 'TV430' },
          { imgSrc: 'TV426.jpg', name: 'Cottage Rose Garden', url: 'https://antiquewhiteart.etsy.com/listing/1714114030', sku: 'TV426' },
          { imgSrc: 'TV589.jpg', name: 'Cottage Rose Garden', url: 'https://antiquewhiteart.etsy.com/listing/1869579514', sku: 'TV589' },
        ];
        
        const defaultItems = [
          { imgSrc: 'S63.jpg', name: 'Wildflower Prints', url: 'https://antiquewhiteart.etsy.com/listing/1656474489', sku: 'S63' },
          { imgSrc: 'S80.jpg', name: '4th of July Set', url: 'https://antiquewhiteart.etsy.com/listing/1724000164', sku: 'S80' },
          { imgSrc: 'S113.jpg', name: '4th of July Set', url: 'https://antiquewhiteart.etsy.com/listing/4303003619', sku: 'S113' },
          { imgSrc: 'A419.jpg', name: 'Cottage Garden', url: 'https://antiquewhiteart.etsy.com/listing/1866579552', sku: 'A419' },
          { imgSrc: 'A444.jpg', name: 'Independence Day', url: 'https://antiquewhiteart.etsy.com/listing/4301726232', sku: 'A444' },
          { imgSrc: 'A248.jpg', name: 'Coastal Wildflowers', url: 'https://antiquewhiteart.etsy.com/listing/4301726232', sku: 'A248' },
          // { imgSrc: 'A401.jpg', name: 'Cottage Garden', url: 'https://antiquewhiteart.etsy.com/listing/1859408150', sku: 'A401' },
          // { imgSrc: 'S79.jpg', name: 'Coastal Set', url: 'https://antiquewhiteart.etsy.com/listing/1734012059', sku: 'S79' },
          // { imgSrc: 'S33.jpg', name: 'Wildflower Set of 6', url: 'https://antiquewhiteart.etsy.com/listing/1468530635', sku: 'S33' },
        ];

        // Determine which items to use based on SKU prefix
        // Use frameItems if SKU starts with TV, TS, or WA, otherwise use defaultItems
        let itemsToUse;
        if (extractedSku && (extractedSku.startsWith('TV') || extractedSku.startsWith('TS') || extractedSku.startsWith('WA'))) {
          itemsToUse = [...frameItems]; // Create a copy to avoid modifying the original array
        } else {
          itemsToUse = [...defaultItems]; // Create a copy to avoid modifying the original array
        }

        // Remove the current SKU from recommendations if it exists
        if (extractedSku) {
          // Filter out any items that have the same SKU
          itemsToUse = itemsToUse.filter(item => item.sku !== extractedSku);
        }

        // Randomly select 4 items (or fewer if not enough items left)
        const maxItems = Math.min(4, itemsToUse.length);
        const selectedItems = itemsToUse.sort(() => 0.5 - Math.random()).slice(0, maxItems);
        setBestsellerImages(selectedItems);
      })
      .catch(error => {
        setLoading(false);
        if (error.response) {
          if (error.response.status === 404) {
            setError1('The page was not found.');
          } else if (error.response.status === 500) {
            setError1('There has been an issue with the files for this order. Please contact us via email contact@antiquewhite.art or Etsy messages at antiquewhiteart.etsy.com for more details.');
          } else {
            // setError('An unexpected error X1790B occurred. Please try again later.');
            const currentUrl = window.location.href;
            const folderIdFromUrl = currentUrl.split('/').pop();
            const googleDriveLink = `https://drive.google.com/drive/folders/${folderIdFromUrl}`;
    
            setError(googleDriveLink); 
          }
        } else {
          const currentUrl = window.location.href;
          const folderIdFromUrl = currentUrl.split('/').pop();
          const googleDriveLink = `https://drive.google.com/drive/folders/${folderIdFromUrl}`;

          setError(googleDriveLink);
        }
      });
  }, [folderId, baseURL]);

  // Handle Mailchimp visibility based on the SKU
  useEffect(() => {
    // Only proceed if we have a valid SKU
    //console.log("currentSKU " + currentSku);
    if (!currentSku) return;
    
    // Determine if we should show Mailchimp popup (only for TV/Frame products)
    const isFrameProduct = currentSku && (
      currentSku.startsWith('TV') || 
      currentSku.startsWith('TS') || 
      currentSku.startsWith('WA')
    );
    
    // Call the global function to control Mailchimp visibility
    if (window.setMailchimpVisibility) {
      window.setMailchimpVisibility(isFrameProduct);
    }
  }, [currentSku]); // This effect runs when currentSku changes

  const handleDownload = async (fileName) => {
    setDownloadingFiles(prevState => ({ ...prevState, [fileName]: true }));
    setDownloadProgress(prevState => ({ ...prevState, [fileName]: 0 }));
  
    try {
      // Send a HEAD request to get the file size
      const headResponse = await axios.head(`${baseURL}/files/download/${folderId}/${fileName}`);
      const totalLength = parseInt(headResponse.headers['content-length'], 10);
  
      axios({
        url: `${baseURL}/files/download/${folderId}/${fileName}`,
        method: 'GET',
        responseType: 'blob',
        onDownloadProgress: (progressEvent) => {
          let progress = 0;
  
          if (totalLength > 0) {
            progress = Math.round((progressEvent.loaded * 100) / totalLength);
            if (progress > 100) progress = 100;
          }
  
          setDownloadProgress(prevState => ({ ...prevState, [fileName]: progress }));
        }
      })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
  
        setDownloadedFiles(prevState => ({ ...prevState, [fileName]: true }));
        setDownloadingFiles(prevState => {
          const newState = { ...prevState };
          delete newState[fileName];
          return newState;
        });
        setDownloadProgress(prevState => {
          const newState = { ...prevState };
          delete newState[fileName];
          return newState;
        });
      })
      .catch(error => {
        console.error('Error downloading file:', error);
        setDownloadingFiles(prevState => {
          const newState = { ...prevState };
          delete newState[fileName];
          alert('The file download failed. Please try again or contact us via email contact@antiquewhite.art or Etsy AntiqueWhiteArt.etsy.com for more details.');
          return newState;
        });
        setDownloadProgress(prevState => {
          const newState = { ...prevState };
          delete newState[fileName];
          return newState;
        });
      });
    } catch (error) {
      console.error('Error getting file size:', error);
      setDownloadingFiles(prevState => {
        const newState = { ...prevState };
        delete newState[fileName];
        alert('Failed to retrieve file size. Please try again or contact us via email contact@antiquewhite.art or Etsy AntiqueWhiteArt.etsy.com for more details.');
        return newState;
      });
    }
  };
  
  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <CircularProgress sx={{ color: '#E1D8D2' }} />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-screen text-center" style={{ padding: '0 16px' }}>
        <Alert 
          severity="error" 
          sx={{ 
            maxWidth: { xs: '90%', sm: '80%', md: '600px' }, // Adjust max width for different screen sizes
            margin: '0 auto',
            padding: { xs: '16px', sm: '24px' }, // Adjust padding for smaller screens
            fontSize: { xs: '14px', sm: '16px', md: '18px' }, // Adjust font size for readability on small screens
          }}
        >
          AntiqueWhiteArt application is under maintenance. Please download files from Google Drive by following the link below:
          <br />
          <br />
          <a href={error} target="_blank" rel="noopener noreferrer">
            <b>
              {error}
            </b>
          </a>
          <br />
          <br />
          Thank you for understanding! In case of any questions, feel free to reach out at
          <br />
          <a href="https://antiquewhiteart.etsy.com" target="_blank" rel="noopener noreferrer">
            <b>
              AntiqueWhiteArt.etsy.com
            </b>
          </a>
        </Alert>
      </div>
    );
  }

  if (error1) {
    return (
      <div className="flex justify-center items-center h-screen text-center">
        <Alert severity="error" sx={{ maxWidth: '600px', margin: '0 auto' }}>
          {error1}
        </Alert>
      </div>
    );
  }

  const handleCopyClick = async () => {
    navigator.clipboard.writeText('WELCOME70');
    setOpenSnackbar(true);
    try {
      await axios.post(`${baseURL}/files/track`, { action_type: 'coupon_copy', file_name: 'WELCOME70' }, { headers: { 'Content-Type': 'application/json' } } );
    } catch (error) {
        console.error('Error tracking coupon copy:', error);
    }
  };

  const handleBestsellerClick = async (item) => {
    try {
        await axios.post(`${baseURL}/files/track`, { action_type: 'bestseller_click', file_name: item.imgSrc },  { headers: { 'Content-Type': 'application/json' } });
    } catch (error) {
        console.error('Error tracking bestseller click:', error);
    }
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar(false);
  };


  const renderFileGroup = (groupKey, groupFiles) => {
    // Find the 5x7 thumbnail if present in the print set
    const thumbnailFile = groupFiles.find(file => file.name.includes('5x7'));

    // Determine which file should be shown based on the thumbnail logic
    const displayFile = thumbnailFile || groupFiles[0]; // Default to the first file if no specific 5x7 thumbnail is found

  
    // Sort files based on the specified order
    groupFiles.sort((a, b) => {
      const aIndex = sortedSizes.findIndex(size => a.name.includes(size));
      const bIndex = sortedSizes.findIndex(size => b.name.includes(size));
      return aIndex - bIndex;
    });
  
    return (
      <Box key={groupKey} className="relative p-4 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 flex flex-col items-center">
        <div className="w-full aspect-w-3 aspect-h-2 mb-4 flex items-center justify-center bg-gray-100 rounded">
          {displayFile.mimeType === 'application/pdf' ? (
            <img src={PdfPlaceholder} alt="PDF Thumbnail" className="object-cover w-full h-full" />
          ) : (
            <img
              src={`data:${displayFile.mimeType};base64,${displayFile.thumbnailBase64}`}
              alt={displayFile.name}
              className="object-cover w-full h-full rounded"
              onContextMenu={(e) => e.preventDefault()}
            />
          )}
        </div>
        <Typography 
          variant="h6" 
          className="text-center"
          sx={{ marginBottom: 1 }}  // Adds bottom margin using MUI's sx prop
        >
          {groupFiles.length > 1 ? `Print ${groupKey.replace(/_Print/, '')}` : displayFile.name.replace(/_Print/, '')}
        </Typography>
  
        {groupFiles.length > 1 ? (
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>Select print size</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <div className="grid grid-cols-1 gap-0">
                {groupFiles.map(file => (
                  <div key={file.name} className="flex flex-col space-between">
                    <div className="flex items-center">
                      <Typography sx={{ marginRight: 2 }}>{file.name.replace(groupKey + '_', '')}</Typography>
                      <Button
                        variant="contained"
                        sx={{
                          marginLeft: 'auto',
                          mt: 1,  // Adds space above each button
                          mb: 1,  // Adds space below each button
                          backgroundColor: downloadedFiles[file.name] ? '#7C6F5E' : '#7C6F5E',
                          color: '#fff',
                          '&:hover': {
                            backgroundColor: downloadedFiles[file.name] ? '#A19179' : '#A19179',
                          },
                        }}
                        startIcon={downloadedFiles[file.name] ? <CheckCircleIcon /> : <DownloadIcon />}
                        onClick={() => handleDownload(file.name)}
                        disabled={downloadingFiles[file.name] !== undefined || downloadedFiles[file.name] !== undefined}
                      >
                        {downloadedFiles[file.name] ? 'Downloaded' : 'Download'}
                      </Button>
                    </div>
                    {downloadingFiles[file.name] && (
                      <div className="w-full mt-2 mb-2">
                        <LinearProgress 
                          variant="determinate" 
                          value={downloadProgress[file.name]} 
                          sx={{ 
                            backgroundColor: '#c2b5a3',
                            '& .MuiLinearProgress-bar': {
                              backgroundColor: '#7C6F5E'
                            }
                          }}
                        />
                        <p className="text-sm text-gray-600 mt-1">{`${downloadProgress[file.name]}%`}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </AccordionDetails>
          </Accordion>
        ) : (
          <>
          {/* Individual download btn */}
            <Button
              variant="contained"
              sx={{
                mt: 'auto',
                backgroundColor: downloadedFiles[displayFile.name] ? '#7C6F5E' : '#7C6F5E',
                color: '#fff',
                '&:hover': {
                  backgroundColor: downloadedFiles[displayFile.name] ? '#A19179' : '#A19179',
                },
              }}
              startIcon={downloadedFiles[displayFile.name] ? <CheckCircleIcon /> : <DownloadIcon />}
              onClick={() => handleDownload(displayFile.name)}
              disabled={downloadingFiles[displayFile.name] !== undefined || downloadedFiles[displayFile.name] !== undefined}
            >
              {downloadedFiles[displayFile.name] ? 'Downloaded' : 'Download'}
            </Button>
            {downloadingFiles[displayFile.name] && (
              <div className="w-full mt-2">
                <LinearProgress 
                  variant="determinate" 
                  value={downloadProgress[displayFile.name]} 
                  sx={{ 
                    backgroundColor: '#c2b5a3',
                    '& .MuiLinearProgress-bar': {
                      backgroundColor: '#7C6F5E'
                    }
                  }}
                />
                <p className="text-sm text-gray-600 mt-1">{`${downloadProgress[displayFile.name]}%`}</p>
              </div>
            )}
          </>
        )}
      </Box>
    );
  };
  
  

  return (
    <div className="w-full py-4" style={{ backgroundColor: '#F6F6F6' }}>
      <div className="flex items-center mb-4 px-4">
        <a href="https://AntiqueWhiteart.etsy.com">
          <img src={Logo} alt="Logo" className="h-[4.5rem] w-[4.5rem] mr-4" />
        </a>
        <h1 className="text-2xl font-bold flex-1 text-center">AntiqueWhiteArt Files</h1>
        <div className="h-[4.5rem] w-[4.5rem]"></div>
      </div>

      {/* Countdown Banner */}
      {showCountdown && (
        <div className="px-4">
          <CountdownBanner sku={currentSku} />
        </div>
      )}
  
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 px-4">
        {Object.keys(files).map(groupKey => renderFileGroup(groupKey, files[groupKey]))}
      </div>
  
      {/* "You May Also Like" Section */}
      <div className="w-full px-4 py-4 my-4" style={{ backgroundColor: 'rgb(231 228 223)' }}>

      <h2 className="font-bold text-center my-4" style={{ fontSize: '1.5rem' }}>Summer 2025 Collection</h2>
        <div className="text-center mb-4">

          <Box 
            display="flex" 
            justifyContent="center" 
            alignItems="center" 
            gap={2}
            flexWrap="wrap" // Allow wrapping on small screens
          >
            <Box display="flex" flexDirection="column" alignItems="center">
              <span className="text-lg font-medium">
                Save 70% with a coupon
              </span>
            </Box>
            <Chip 
              label={
                <Box display="flex" alignItems="center">
                  <span style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>WELCOME70</span> {/* Increased size */}
                  <ContentCopyIcon 
                    onClick={handleCopyClick}
                    sx={{ 
                      cursor: 'pointer', 
                      color: '#00796B', 
                      fontSize: '1.2rem', // Increased size
                      ml: 0.5 
                    }} 
                  />
                </Box>
              }
              sx={{ 
                backgroundColor: '#E0F2F1', 
                color: '#00796B', 
                fontWeight: 'bold',
                px: 1.5, // Default padding for larger screens
                py: 0.5, // Default padding for larger screens
                '@media (max-width: 600px)': { // Responsive behavior
                  minWidth: '50%', // Make it take the full width on small screens
                  justifyContent: 'center',
                  px: 1, // Narrower padding on smaller screens
                  py: 1.5, // Taller padding on smaller screens
                },
              }} 
            />
          </Box>

          <Snackbar
            open={openSnackbar}
            autoHideDuration={3000}
            onClose={handleCloseSnackbar}
            message="Coupon code WELCOME70 copied to clipboard"
            action={
              <React.Fragment>
                <ContentCopyIcon  size="small" aria-label="close" color="inherit" onClick={handleCloseSnackbar}>
                  <CloseIcon fontSize="small" />
                </ContentCopyIcon >
              </React.Fragment>
            }
          />

        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {bestsellerImages.map((item, index) => {
            // Check if we have a valid image to show
            const imageSrc = safelyLoadImage(item.imgSrc);
            const hasFailedToLoad = failedImages[index];
            
            return (
              <a key={index} href={item.url} target="_blank" rel="noopener noreferrer" className="no-underline text-black" onClick={() => handleBestsellerClick(item)}>
                <div className="relative p-4 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 flex flex-col items-center">
                  {imageSrc && !hasFailedToLoad ? (
                    <img
                      src={imageSrc}
                      alt={item.name}
                      className="object-cover w-full h-full rounded"
                      onError={() => handleImageError(index)}
                    />
                  ) : (
                    <div 
                      className="w-full aspect-w-4 aspect-h-3 rounded bg-gray-100 flex items-center justify-center"
                      style={{ minHeight: "200px" }}
                    >
                      <p className="text-gray-400 text-sm">{item.name}</p>
                    </div>
                  )}
                  <div className="text-center mt-4">
                    <p className="text-lg font-medium">{item.name}</p>
                  </div>
                </div>
              </a>
            );
          })}
        </div>

      </div>

      <FAQ />

      {/* Thank You Image */}
      <Box display="flex" justifyContent="center" mt={4} mb={4}>
        {safelyLoadImage('thank-you.png') ? (
          <Box
            component="img"
            src={safelyLoadImage('thank-you.png')}
            alt="Thank You"
            onError={(e) => {
              e.target.style.display = 'none'; // Hide the image on error
            }}
            sx={{
              maxWidth: '100%',
              height: 'auto',
              width: {
                xs: '70%',
                sm: '50%',
                md: '35%',
                lg: '30%',
                xl: '25%',
              },
            }}
          />
        ) : (
          <Typography 
            variant="h5" 
            align="center" 
            color="textSecondary"
            sx={{ my: 4 }}
          >
            Thank You For Your Order!
          </Typography>
        )}
      </Box>
  
      <footer className="w-full py-4 text-center" style={{ backgroundColor: '#F6F6F6' }}>
        <p className="text-sm text-gray-500">Please note that images on this page are only for personal, non-commercial use.<br></br>For a detailed license, please visit antiquewhite.art</p>
        <p className="text-sm text-gray-500">© AntiqueWhiteArt</p>
        <p className="text-sm text-gray-500">{new Date().getFullYear()} All rights reserved</p>
      </footer>
    </div>
  );
};

export default FileList;
